
import { StyledTextareaAutosize, Wrap } from './styles';

import {
  InputIntegerMask,
  InputDecimalMask,
  InputDateMask,
} from './inputMaskType';

import Icon from '@map/components/Icons';
import Input from '@material-ui/core/Input';
// import TextareaAutosize from '@mui/base/TextareaAutosize';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useEffect, useRef, useState } from 'react';

/**
 * 
 * @param {*} param0 
 * @param {*} data
 * @param {integer} numberFeatures Numero de total de feiçoes das camadas
 * @param {object} layerType
 * @param {boolean} isEditableColumn Verifica se a coluna é editavel
 * @param {boolean} isShowInputCell Mostra celular de entrada
 * @param {boolean} setIsShowInputCell Seta o estado da celular
 * @param {function} changeCell Atualiza a celula
 * @param {} customColumnsType
 * @param {function} openPopupFormColumn Recebe um evento para abrir o popup
 * @param {function} onSort Ordena a coluna e a direção
 * @param {object} selectedLabelColumn Coluna definida como rotulo
 * @param {function} onClickColumn Recebe um click para saber qual coluna esta selecionada
 * @param {boolean} isSelectedCol Retorna se a coluna esta selecionada
 * @param {function} onClickRow Recebe um clicl para saber qual linha esta selecionada
 * @param {*} dbClickCell
 * @param {boolean} isSelectedRow Retorna se a linha esta selecionada
 * @param {boolean} setHighlightLineInEdit
 * @param {boolean} highlightLineInEdit
 * @param {*} props Resto
 * 
 * @returns 
 */
const Table = ({
  columns,
  layer,
  data,
  numberFeatures,
  layerType,
  isEditableColumn,
  isShowInputCell,
  setIsShowInputCell,
  changeCell,
  customColumnsType,
  openPopupFormColumn,
  onSort,
  selectedLabelColumn,
  onClickColumn,
  isSelectedCol,
  onClickRow,
  dbClickCell,
  isSelectedRow,
  setHighlightLineInEdit,
  highlightLineInEdit,
  filterColumn,
  ...props
}) => {
  const [sortColunm, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [cellClicked, setCellClicked] = useState(null);
  const [valueInputCell, setValueInputCell] = useState('');  
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.focus();
      textareaRef.current.setSelectionRange(valueInputCell.length, valueInputCell.length);
    }
  }, [valueInputCell]); // Chama ao atualizar o valor do input

  
  /**
   * Ordena registros pela coluna especificada
   *
   * @param {string} columnName
   */
  const handleSort = (columnName) => {
    if (columnName === sortColunm) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
      onSort && onSort(columnName, sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortDirection('asc');
      setSortColumn(columnName);
      onSort && onSort(columnName, 'asc');
    }
  };

  /**
   * Obtém a máscara de acordo com a coluna especificada
   *
   * @param {string} columnName
   */
  const getMask = (columnName) => {
    let mask = InputIntegerMask;
    switch (customColumnsType[columnName]) {
      case 'integer':
        mask = InputIntegerMask;
        break;
      case 'decimal':
        mask = InputDecimalMask;
        break;
      case 'date':
        mask = InputDateMask;
        break;
      default:
        break;
    }
    return mask;
  };

  /**
   * Obtém o tamanho máximo da coluna
   *
   * @param {string} columnName
   */
  const getMaxLength = (columnName) => {
    let maxLength = layer.dataType === 'Text'
                      ? 50
                      : 254;

    
    switch (customColumnsType[columnName]) {
      case 'integer':
        maxLength = 9;
        break;
      case 'decimal':
        maxLength = 17;
        break;
      case 'date':
        maxLength = 10;
        break;
      default:
        break;
    }
    return maxLength;
  };  

  return (
    <Wrap>
      <table>
        <thead>
          {columns.map((column, index) => {
            if (column.display !== false) {
              return (
                <th
                  {...column.options}
                  key={index}
                  title={
                    selectedLabelColumn &&
                    selectedLabelColumn.name === column.name
                      ? 'Esta coluna foi definida como rótulo dessa camada.'
                      : ''
                  }
                  className={`${column.name === sortColunm && 'sorting'}
                  ${
                    selectedLabelColumn &&
                    selectedLabelColumn.name === column.name &&
                    'selected-label-column'
                  }
                  ${column.name !== 'bbox' && 'column-editable'}
                  ${isSelectedCol(column) && 'column-selected'}`}
                  onClick={(e) => onClickColumn && onClickColumn(e, column)}
                  onDoubleClick={(e) => {
                    if (
                      !isShowInputCell &&
                      (layerType === 'criada' || layerType === 'importada') &&
                      layer.dataType !== 'Text' &&
                      isEditableColumn(column)
                    ) {
                      openPopupFormColumn(
                        e,
                        column.name,
                        customColumnsType[column.name]
                      );
                    }
                  }}
                >
                  {column.customRenderHeader ? (
                    column.customRenderHeader(column)
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      {column.label}              
                      {column.sort !== false && (
                        <div
                          className={`sort-icon ${
                            column.name === sortColunm && sortDirection
                          }`}
                          onClick={() => column.sort && handleSort(column.name)}
                        >
                          <Icon i="map-chevrondown" />
                        </div>
                      )}
                    </div>
                  )}
                </th>
              );
            }
            return null;
          })}
        </thead>
        <tbody>
        {(data || []).map((row, iRow) => {
            return (
              <tr
                key={iRow}
                onClick={(e) => onClickRow && onClickRow(e, row)}
                className={`
                  ${isSelectedRow && isSelectedRow(row)? 'selected' : ''}
                  ${cellClicked && 
                    ('ID_GBA' in cellClicked.row && cellClicked.row.ID_GBA === row.ID_GBA) && 
                      highlightLineInEdit ? 'highlightLine' : ''
                  }
                `}
              >
                {columns.map((column, iColumn) => {
                  if (column.display !== false) {
                    return (
                      <td
                        key={iColumn}
                        // className={`
                        // ${
                        //   selectedLabelColumn &&
                        //   selectedLabelColumn.name === column.name &&
                        //   'selected-label-column'
                        // }`}
                        onDoubleClick={(e) => {                          
                          if (!isShowInputCell &&
                            (layerType === 'criada' || layerType === 'importada') &&
                            isEditableColumn(column)
                          ) {
                            setIsShowInputCell(true);
                            setCellClicked({ row: row, column: column });
                            setValueInputCell(e.target.innerHTML);
                          } else if (
                            isShowInputCell && 
                              ('ID_GBA' in cellClicked.row && cellClicked.row.ID_GBA !== row.ID_GBA)
                          ) {                              
                            setHighlightLineInEdit(true);
                          }
                        }}
                      >

                        {isShowInputCell &&
                          cellClicked &&
                          ('ID_GBA' in cellClicked.row && cellClicked.row.ID_GBA === row.ID_GBA) &&                          
                          cellClicked.column.name === column.name 
                            ? layer.dataType === 'Text'
                              ? (<>
                              <StyledTextareaAutosize
                                  ref={textareaRef}
                                  placeholder="Valor da coluna"
                                  name="column-value"
                                  className={`text-field ${highlightLineInEdit ? ' highlightLine' : ''}`}
                                  type="text"
                                  maxLength={getMaxLength(column.name)}
                                  value={valueInputCell}
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    setValueInputCell(e.target.value);
                                    changeCell(e, row, column);
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                  autoFocus
                                  highlightLineInEdit={highlightLineInEdit}
                                />
                                                              
                         </>)
                              : (
                              <Input
                                  placeholder="Valor da coluna"
                                  name="column-value"                              
                                  className={`
                                    text-field
                                    ${highlightLineInEdit 
                                      ? ' highlightLine' 
                                      : ''}
                                  `}
                                  type="text"
                                  inputProps={{
                                    maxLength: getMaxLength(column.name),
                                  }}
                                  value={valueInputCell}
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    setValueInputCell(e.target.value);
                                    changeCell(e, row, column);
                                  }}
                                  onFocus={(e) => {
                                    // Remove o atributo 'style' criado dinamicamente
                                    // quando o valor do tipo data é informado errado
                                    e.target.removeAttribute('style');
                                    setHighlightLineInEdit(false);
                                    e.stopPropagation();
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                  autoFocus
                                  {...(customColumnsType[column.name] &&
                                  customColumnsType[column.name] !== 'string'
                                    ? { inputComponent: getMask(column.name) }
                                    : '')}
                                />
                              ) 
                            : column.customRenderBody 
                              ? (column.customRenderBody(row[column.name], row, iRow)) 
                              : ((column.name.includes("rea (m"))||(column.name.includes("rea (ha"))||(column.name.includes("Compriment"))
                                ? row[column.name].toLocaleString('pt-BR')
                                : row[column.name])
                        }
                      </td>
                    );
                  }
                  return null;
                })}
              </tr>
            );
          })}
        </tbody>
        {
          numberFeatures && 
          layer && 
          (
            <div className='counterDiv'>
              <p>
                Total de feições: {numberFeatures}, 
                Filtrada: {filterColumn ? data.length : 0} , 
                Selecionadas: {isSelectedRow ? layer.selectedFeatures.length : 0 }              
              </p>
            </div>
          )
        }
      </table>
    </Wrap>
  );
};

Table.properties = {
  ignore: true,
};

export default Table;
